import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { ko } from 'date-fns/locale';
import { forwardRef } from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { useLinearLocale } from '../../locale/LocaleContext.mjs';
import { useDatePickerContext } from '../context/datePickerContext.mjs';
import { calendar } from '../datePicker.vanilla.mjs';
import { dayOverride } from '../dayOverride.vanilla.mjs';
import { onDateChangeWhenChanged } from '../utils/date.mjs';
import { DayText } from './base/day.mjs';
import { MultiMonthViewHeader, MonthViewHeader } from './base/month.mjs';

registerLocale("ko", ko);
const CALENDAR_NAME = "Calendar";
const Calendar = forwardRef(
  (props, ref) => {
    const {
      className,
      dayClassName,
      onChange,
      disabled: disabledFromProps,
      monthsShown = 1,
      renderHeader = (headerProps) => monthsShown > 1 ? /* @__PURE__ */ jsx(MultiMonthViewHeader, { monthsShown, ...headerProps }) : /* @__PURE__ */ jsx(MonthViewHeader, { ...headerProps }),
      renderDay = (dayOfMonth, date) => /* @__PURE__ */ jsx(DayText, { dayOfMonth, date }),
      fixedHeight = true,
      onMonthChange,
      highlightDates,
      onDayMouseEnter,
      onMonthMouseLeave,
      __scopeDatePicker
    } = props;
    const ctx = useDatePickerContext(CALENDAR_NAME, __scopeDatePicker);
    const {
      disabled,
      mode,
      selectedDate,
      onDateChange: onDateChangeFromContext,
      startDate,
      endDate,
      onEndDateChange,
      onStartDateChange,
      minDate,
      maxDate,
      excludeDates,
      includeDateIntervals,
      openToDate
    } = ctx;
    const { locale } = useLinearLocale();
    const isRangeMode = mode === "range";
    const isEndDateAvailable = isRangeMode && startDate !== null;
    return /* @__PURE__ */ jsx(
      ReactDatePicker,
      {
        inline: true,
        fixedHeight,
        ref,
        selectsRange: isRangeMode,
        locale,
        disabled: disabled || disabledFromProps,
        selected: isRangeMode ? void 0 : selectedDate,
        startDate: isRangeMode ? startDate : void 0,
        endDate: isEndDateAvailable ? endDate : void 0,
        monthsShown,
        calendarClassName: classNames(calendar, className),
        renderCustomHeader: renderHeader,
        dayClassName: (...params) => classNames(dayOverride, dayClassName ? dayClassName(...params) : ""),
        shouldCloseOnSelect: false,
        renderDayContents: renderDay,
        minDate: minDate ?? void 0,
        maxDate: maxDate ?? void 0,
        excludeDates,
        includeDateIntervals,
        onChange: (...params) => {
          onChange?.(...params);
          const [updatedDate] = params;
          if (disabled) {
            return;
          }
          if (Array.isArray(updatedDate)) {
            onDateChangeWhenChanged(
              { date: startDate, changedDate: updatedDate[0] },
              onStartDateChange
            );
            onDateChangeWhenChanged(
              { date: endDate, changedDate: updatedDate[1] },
              onEndDateChange
            );
          } else {
            onDateChangeWhenChanged(
              { date: selectedDate, changedDate: updatedDate },
              onDateChangeFromContext
            );
          }
        },
        openToDate,
        onMonthChange,
        highlightDates,
        onDayMouseEnter,
        onMonthMouseLeave
      }
    );
  }
);

export { Calendar as default };
//# sourceMappingURL=Calendar.mjs.map
